import React, { PureComponent } from 'react'
import { Card, Grid, Typography } from '@material-ui/core'

export default class LimitContainerDetail extends PureComponent {
  render() {
    const { limitDetail = {} } = this.props
    const cannabisTypes = limitDetail.mapping.join(', ')
    const conversionMap = limitDetail.conversionMap || {}

    const conversionList = Object.entries(conversionMap).map(([key, value]) => {
      const { numerator, denominator } = value.cannabisConversionDefinition.ratio
      const ratioValue = numerator / denominator
      const displayName = (value.displayMetadata && value.displayMetadata.displayName) || ''
      return { type: displayName, ratioValue }
    })

    const renderCard = (content) => (
      <Card
        style={{
          margin: '10px',
          padding: '10px 30px',
          boxShadow: '0px 10px 10px rgba(0, 0, 0, 0.5)',
        }}
      >
        <Grid container>{content}</Grid>
      </Card>
    )

    return (
      <Grid container>
        {conversionList.length > 0
          ? conversionList.map((item, index) => 
              renderCard(
                <div>
                  <Grid item>
                    <Typography>{item.type}</Typography>
                  </Grid>
                  <Grid item style={{ marginLeft: '5px' }}>
                    <Typography>{`-> ratio: ${item.ratioValue}`}</Typography>
                  </Grid>
                </div>
              )
            )
          : renderCard(
              <Grid item>
                <Typography>{`Cannabis Type: ${cannabisTypes}`}</Typography>
              </Grid>
            )}
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/LimitV2/LimitContainerDetail.js